import { Vec3 } from 'features/assetViz/utils/helpers'
import React from 'react'
import { GeckoFeature, GeckoMeasurement, GeckoMeasurementUnit } from 'types'

import { FeatureCylinder3D } from './FeatureCylinder3D'

/**
 * A ring of bolts, usually at the end of a manway or nozzle. Bolts are given
 * @param feature       The feature these bolts belong to
 * @param position      The position of the center of this bolt ring in space
 * @param radius        The radius surrounded by bolts (all bolts are outside)
 * @param scale         Optional. Number to scale the size/radius of the bolts. Default is 1.
 *                      Default radius of each bolt is 1cm.
 * @constructor
 */
export const FeatureBoltRing3D: React.FC<{
  feature: GeckoFeature
  position: Vec3
  radius: GeckoMeasurement
  scale?: number
}> = ({ feature, position, radius, scale = 1 }) => {
  //----------------------------------------------------------------------------

  const { boltPositions, boltRadius } = React.useMemo(() => {
    const diameterInInches = radius
      .scale(2.0)
      .toNumber(GeckoMeasurementUnit.Inches)

    let numOfBolts = 4
    if (diameterInInches >= 36) numOfBolts = 24
    else if (diameterInInches >= 32) numOfBolts = 24
    else if (diameterInInches >= 24) numOfBolts = 20
    else if (diameterInInches >= 20) numOfBolts = 16
    else if (diameterInInches >= 16) numOfBolts = 14
    else if (diameterInInches >= 12) numOfBolts = 12
    else if (diameterInInches >= 10) numOfBolts = 10
    else if (diameterInInches >= 8) numOfBolts = 8
    else if (diameterInInches >= 6) numOfBolts = 6

    const r = radius.num + 0.01 * scale
    const positions: Array<Vec3> = []
    for (let i = 0; i < numOfBolts; i++) {
      const angle = (i / numOfBolts) * 2.0 * Math.PI
      positions.push([r * Math.sin(angle), 0, r * Math.cos(angle)])
    }
    return { boltPositions: positions, boltRadius: 0.01 * scale }
  }, [radius, scale])

  return (
    <group position={position}>
      {boltPositions.map((position, i) => (
        <FeatureCylinder3D
          key={`bolt_${i}`}
          feature={feature}
          position={position}
          radius={boltRadius}
          height={0.01 * scale}
          debugColor={'green'}
        />
      ))}
    </group>
  )
}
